import { convertFromRaw, EditorState } from 'draft-js';

export default function convertToEditorState(content) {
  if (!content) {
    return EditorState.createEmpty();
  }

  try {
    const contentState = convertFromRaw(content);
    return EditorState.createWithContent(contentState);
  } catch (e) {
    return EditorState.createEmpty();
  }
}